// Primary brand language is a product invariant. Do not replace or paraphrase it.
export const PRIMARY_STRAPLINE = "Network Intelligence at the Speed of Light";
export const PRIMARY_STRAPLINE_LINES = ["Network Intelligence", "at the Speed of Light"];
export const PRIMARY_BRAND_LOCKUP = `LightningFlow — ${PRIMARY_STRAPLINE}`;
